export default __webpack_public_path__ + "static/media/Proposal.ef909801.pdf";